import request from '@/utils/request'
// 获取卡操作记录列表
export function cardOperationPage(data) {
    return request({
      url: '/card/operation/page',
      method: 'post',
      data: data
    })
}
//获取操作记录条数（处理中）
export function cardOperationCount(data) {
  return request({
    url: '/card/operation/count',
    method: 'get',
    params: data
  })
}

// 获取卡类型树
export function cardTypeTree(data) {
  return request({
    url: '/cardType/treeList',
    method: 'get',
    params: data
  })
}
// 获取物理卡类型
export function cardTypeNameList(data) {
  return request({
    url: '/cardType/names',
    method: 'post',
    data: data
  })
}

//刷新数据
export function refreshCardType(data) {
  return request({
    url: '/cardType/refresh',
    method: 'get',
    params: data
  })
}